export const getExpenseTabs = (mode = 'management') => {
    if (mode === 'management') {
        return [
            { key: 'all', label: 'All Expenses' },
            { key: 'approved', label: 'Approved' },
            { key: 'rejected', label: 'Rejected' },
            { key: 'pending-reimbursement', label: 'Pending Reimbursement' }
        ];
    }

    return [];
};

export const buildExpenseListParams = ({ mode = 'management', periodFilters = {}, filters = {}, q = '' }) => ({
    ...periodFilters,
    expense_type: filters.expense_type || undefined,
    category_id: filters.category || undefined,
    sub_category_id: filters.sub_category || undefined,
    plate_no: filters.plate_no || undefined,
    min_amount: filters.min_amount || undefined,
    max_amount: filters.max_amount || undefined,
    approval_status: mode === 'approvals' ? 'PENDING' : (filters.approval_status || undefined),
    q: q || undefined
});
